<div *fesListView="let fesListTestPoints of testPoints">
  <table
    class="path-test-points-table table table-striped table-bordered table-sm mb-0"
  >
    <thead>
      <tr>
        <th
          fesSortField="order"
          [sortType]="'numeric'"
          style="width: 2em"
          *ngIf="pathTest.type === 'path test'"
        >
          Order
        </th>
        <th
          fesSortField="order"
          [sortType]="'numeric'"
          style="width: 2em"
          *ngIf="pathTest.type === 'drive test'"
        >
          Drive
        </th>
        <th
          fesSortField="pointId"
          style="width: 9em"
          *ngIf="pathTest.type === 'path test'"
        >
          Test Point
        </th>
        <th
          *ngIf="visibleColumns.waypoint && pathTest.type === 'path test'"
          style="width: 2em"
          fesSortField="waypointOrder"
          [valueResolver]="waypointSortResolver"
          [sortType]="'numeric'"
        >
          Waypoint
        </th>
        <th
          *ngIf="visibleColumns.scoutPtInfo"
          class="text-center"
          style="width: 12em"
        >
          Scout Point
        </th>
        <th
          *ngIf="visibleColumns.environment"
          class="text-center"
          style="width: 20em"
        >
          Environment
        </th>
        <th
          *ngIf="visibleColumns.callCounts && pathTest.type === 'path test'"
          style="width: 4em"
          fesSortField="callsCompleted"
          [valueResolver]="latestSeqDataSortResolver"
          [sortType]="'numeric'"
        >
          Calls
        </th>
        <th
          *ngIf="pathTest.type === 'drive test'"
          style="width: 4em"
          fesSortField="callsCompleted"
          [valueResolver]="latestSeqDataSortResolver"
          [sortType]="'numeric'"
        >
          Route
        </th>
        <th
          *ngIf="visibleColumns.time"
          style="width: 10em"
          fesSortField="startTime"
          [valueResolver]="latestSeqSortResolver"
        >
          Time ({{ tz }})
        </th>
        <th *ngIf="visibleColumns.comments" class="text-center">Comments</th>
        <th fesSortField="statusId" style="width: 10em">Status</th>
        <th *ngIf="editFn" class="small text-center" style="width: 3em"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="pathTest.type === 'drive test'">
        <tr *ngFor="let t of testPoints; let indexOfelement = index">
          <td role="button" class="text-center font-weight-bold">
            #{{ indexOfelement + 1 }}
          </td>
          <td role="button" class="text-center font-weight-bold">
            {{ t.routeId }}
          </td>
          <td
            class="status-cell text-center align-middle"
            [ngClass]="t.statusId | taskStatusCss"
          >
            <div class="font-weight-bolder">
              {{ t.statusId | taskStatusName | titlecase }}
            </div>
          </td>
          <td *ngIf="editFn" class="text-center align-middle">
            <a
              class="text-nowrap font-smaller"
              href="javascript:false;"
              *ngIf="t.statusId != StatusIds.NOT_USING"
              (click)="editFnDrive(t)"
              >edit</a
            >
          </td>
        </tr>
      </ng-container>
      <ng-container *ngIf="pathTest.type === 'path test'">
        <tr
          *ngFor="let testPoint of fesListTestPoints"
          [ngClass]="testPoint.statusId | taskStatusCss"
        >
          <ng-container
            *ngLet="mapData?.mapPointsByTestPtId[testPoint.id] as mapPoint"
          >          
            <ng-container
              *ngLet="
                testPoint.seqs &&
                testPoint.seqs[testPoint.seqs.length - 1] as seq
              "
            >
            <ng-container *ngLet="scoutPointInfoByPtId?.[testPoint.pointId] as scoutInfo">
              <td
                role="button"
                (click)="onClickOrder(testPoint)"
                class="text-center font-weight-bold"
              >
                #{{ testPoint.order }}
              </td>
              <td>
                <a
                  href="javascript:false"
                  (click)="onClickPointId(testPoint)"
                  class="text-nowrap"
                  >{{ testPoint.pointId }}</a
                >
              </td>
              <td
                *ngIf="visibleColumns.waypoint"
                role="button"
                (click)="onClickMapPoint(testPoint)"
                class="waypoint-cell text-center"
              >
                <div class="d-flex justify-content-center">
                  <div
                    class="waypoint-div"
                    *ngIf="mapPoint"
                    [ngStyle]="{
                      'border-color': mapPoint?.color,
                      'background-color':
                        selectedTestPoint?.id === testPoint.id
                          ? 'yellow'
                          : 'white'
                    }"
                  >
                    {{ mapPoint?.name }}
                  </div>
                </div>
              </td>
              <td *ngIf="visibleColumns.scoutPtInfo">
                <i class="fa fa-spinner fa-spin"
                *ngIf="initializingScoutInfoByPtId"></i>
                <app-scout-point-photo-links
                *ngIf="scoutInfo?.scoutPoint"
                [uiLocked]="true"
                [scoutPoint]="scoutInfo.scoutPoint"
                [bShowPhotoSummary]="true"
                [scoutTask]="scoutInfo.scout"
                [scoutPath]="scoutInfo.scoutPath"
                [photoBtnContentTmplRef]="photoBtnContentTmpl"
              ></app-scout-point-photo-links>
              <ng-template #photoBtnContentTmpl let-photo="photo" let-grpDef="grpDef" let-context="context">
                <i class="fa" [ngClass]="context?.iconCssClass"
                  [ngStyle]="{'background-color': 'rgb(255,255,0,'+photo['bgAlpha']+')'}"></i>
              </ng-template>
              </td>
              <td *ngIf="visibleColumns.environment" class="p-0 m-0">
                <ng-container
                  [ngTemplateOutlet]="envTemplate"
                  [ngTemplateOutletContext]="{ seq: seq }"
                >
                </ng-container>
              </td>
              <ng-container *ngIf="visibleColumns.callCounts">
                <td>
                  <div
                    class="text-center"
                    *ngIf="
                      seq?.data?.callsPlaced != null ||
                      seq?.data?.callsCompleted != null
                    "
                  >
                    {{ seq.data.callsCompleted || 0 }} /
                    {{ seq.data.callsPlaced || 0 }}
                  </div>
                </td>
              </ng-container>
              <td *ngIf="visibleColumns.time">
                {{ seq?.startTime | date : "yyyy-MM-dd HH:mm:ss" }}
                <!--div *ngIf="seq.startTime" class="small text-secondary">
              {{seq|seqDuration}}
            </div-->
              </td>
              <td *ngIf="visibleColumns.comments" class="p-0">
                <app-path-test-point-seq-comments [seq]="seq">
                </app-path-test-point-seq-comments>
              </td>
              <td
                class="status-cell text-center align-middle"
                [ngClass]="testPoint.statusId | taskStatusCss"
              >
              <div class="d-flex flex-fill h-100 w-100 align-content-center justify-content-center">
                <i class="fa fa-spinner fa-spin mr-2" *ngIf="savingStatusId&&savingStatusId===testPoint.id"></i>
                <ng-container
                  *ngIf="
                    roleMgr.canEditUsers &&
                      ((testPoint.statusId === StatusIds.NOT_USING && !(scoutInfo?.scoutPoint&&scoutInfo.scoutPoint.disabled)) ||
                        testPoint.statusId === StatusIds.NOT_STARTED);
                    else readOnlyStatus
                  "
                >
                  <select
                    id="status-select"
                    class="text-center align-middle w-100 h-100 m-0 p-1 border-none"
                    [disabled]="savingStatusId&&savingStatusId===testPoint.id"
                    [ngClass]="testPoint.statusId | taskStatusCss"
                    [ngModel]="testPoint.statusId"
                    (change)="onTestPointStatusEdited(testPoint, $event)"
                  >
                    <option class="status-not-started-text" value="1">
                      Not Started
                    </option>
                    <option class="status-not-using-text" value="6">
                      Not Using
                    </option>
                  </select>
                </ng-container>
                <ng-template #readOnlyStatus>
                  <div class="font-weight-bolder">
                    {{ testPoint.statusId | taskStatusName | titlecase }}
                  </div>
                </ng-template>
              </div>
                <div
                  *ngIf="visibleColumns.seqStatus && seq?.startTime"
                  class="seq-status m-1"
                >
                  <app-path-test-point-seq-status
                    [pathTestDoc]="pathTest"
                    [testPoint]="testPoint"
                    [seq]="seq"
                  >
                  </app-path-test-point-seq-status>
                </div>
              </td>
              <td *ngIf="editFn" class="text-center align-middle">
                <div *ngIf="scoutInfo?.scoutPoint&&scoutInfo.scoutPoint.disabled; else scoutPointEnabled"
              class="text-secondary font-italic text-wrap sm small">
              Disabled Scout Point
              </div>
              <ng-template #scoutPointEnabled>
                <a
                  class="text-nowrap font-smaller"
                  href="javascript:false;"
                  *ngIf="testPoint.statusId != StatusIds.NOT_USING"
                  (click)="editFn(testPoint)"
                  >edit</a
                >
                </ng-template>
              </td>
            </ng-container>
          </ng-container>
        </ng-container>

        </tr>
      </ng-container>
    </tbody>
  </table>
  <div
    class="d-flex justify-content-center mt-2"
    *ngIf="pathTest.type === 'drive test'"
  >
    <button
      class="btn btn-secondary"
      (click)="onClickAddDrive()"
      title="Add a new drive"
    >
      <i class="fa fa-plus"></i>
    </button>
  </div>
</div>

<ng-template #envTemplate let-seq="seq">
  <ng-container *ngIf="seq?.data">
    <div class="small text-left d-inline-block">
      <div class="d-flex flex-wrap">
        <div class="p-1">
          <div class="text-secondary font-italic">Conditions</div>
          <table class="table env-table table-sm m-0">
            <tr>
              <td class="env-prop-name">HVAC</td>
              <td class="px-1">
                {{ seq.data.hvac != null ? seq.data.hvac : "---" }}
              </td>
            </tr>
            <tr>
              <td class="env-prop-name">Door open/shut</td>
              <td class="px-1">
                {{
                  seq.data.doorOpenShutCount != null
                    ? seq.data.doorOpenShutCount
                    : "---"
                }}
              </td>
            </tr>
            <tr>
              <td class="env-prop-name">Foot Traffic</td>
              <td class="px-1">
                {{
                  seq.data.footTraffic != null ? seq.data.footTraffic : "---"
                }}
              </td>
            </tr>
          </table>
        </div>
        <div class="p-1">
          <div class="text-secondary font-italic">Participant Coverage</div>
          <table class="table env-table table-sm m-0">
            <tr *ngFor="let participant of pathTestService.participants">
              <td class="env-prop-name">{{ participant.title }} (dBm)</td>
              <td class="px-1">
                {{
                  seq?.data && seq.data[participant.name] != null
                    ? seq.data[participant.name]
                    : "---"
                }}
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="d-inline-block p-1">
        <table class="table env-table table-sm m-0">
          <tr>
            <td class="env-prop-name">Issues with test location?</td>
            <td class="px-1">
              {{ seq.data.issues != null ? seq.data.issues : "---" }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </ng-container>
</ng-template>
